export const questionnaireConstants = {
  QUESTIONNAIRE_EDIT_TITLE: 'QUESTIONNAIRE_EDIT_TITLE',
  QUESTIONNAIRE_SET_TITLE: 'QUESTIONNAIRE_SET_TITLE',
  QUESTIONNAIRE_SET_PATIENT_TYPE: 'QUESTIONNAIRE_SET_PATIENT_TYPE',
  QUESTIONNAIRE_SET_APPOINTMENT_TYPE: 'QUESTIONNAIRE_SET_APPOINTMENT_TYPE',
  QUESTIONNAIRE_SET_SIGNATURE: 'QUESTIONNAIRE_SET_SIGNATURE',

  QUESTIONNAIRE_ADD_ITEM: 'QUESTIONNAIRE_ADD_ITEM',
  QUESTIONNAIRE_REMOVE_ITEM: 'QUESTIONNAIRE_REMOVE_ITEM',
  QUESTIONNAIRE_EDIT_QUESTION: 'QUESTIONNAIRE_EDIT_QUESTION',

  QUESTIONNAIRE_MARK_AS_NOTE: 'QUESTIONNAIRE_MARK_AS_NOTE',
  QUESTIONNAIRE_MARK_AS_REQUIRED: 'QUESTIONNAIRE_MARK_AS_REQUIRED',

  QUESTIONNAIRE_ADD_OPTION: 'QUESTIONNAIRE_ADD_OPTION',
  QUESTIONNAIRE_REMOVE_OPTION: 'QUESTIONNAIRE_REMOVE_OPTION',
  QUESTIONNAIRE_UPDATE_OPTION: 'QUESTIONNAIRE_UPDATE_OPTION',
  QUESTIONNAIRE_SET_CHOICE_TYPE: 'QUESTIONNAIRE_SET_CHOICE_TYPE',

  QUESTIONNAIRE_ANSWER_QUESTION: 'QUESTIONNAIRE_ANSWER_QUESTION',

  QUESTIONNAIRE_SET_NOTE_TEMPLATE: 'QUESTIONNAIRE_SET_NOTE_TEMPLATE',
  QUESTIONNAIRE_SET_NOTE_PREVIEW: 'QUESTIONNAIRE_SET_NOTE_PREVIEW',

  QUESTIONNAIRE_SET_ITEM_TEXT: 'QUESTIONNAIRE_SET_ITEM_TEXT',

  QUESTIONNAIRE_SET_SUPPORT_IMAGE: 'QUESTIONNAIRE_SET_SUPPORT_IMAGE',
  QUESTIONNAIRE_SET_SUPPORT_LINK: 'QUESTIONNAIRE_SET_SUPPORT_LINK',

  QUESTIONNAIRE_SAVE_REQUEST: 'QUESTIONNAIRE_SAVE_REQUEST',
  QUESTIONNAIRE_SAVE_SUCCESS: 'QUESTIONNAIRE_SAVE_SUCCESS',
  QUESTIONNAIRE_SAVE_FAILURE: 'QUESTIONNAIRE_SAVE_FAILURE',

  QUESTIONNAIRE_GETALL_REQUEST: 'QUESTIONNAIRE_GETALL_REQUEST',
  QUESTIONNAIRE_GETALL_SUCCESS: 'QUESTIONNAIRE_GETALL_SUCCESS',
  QUESTIONNAIRE_GETALL_FAILURE: 'QUESTIONNAIRE_GETALL_FAILURE',

  QUESTIONNAIRE_GET_REQUEST: 'QUESTIONNAIRE_GET_REQUEST',
  QUESTIONNAIRE_GET_SUCCESS: 'QUESTIONNAIRE_GET_SUCCESS',

  QUESTIONNAIRE_REARRANGE_ITEMS: 'QUESTIONNAIRE_REARRANGE_ITEMS',
  QUESTIONNAIRE_RESET_IDS: 'QUESTIONNAIRE_RESET_IDS',
  QUESTIONNAIRE_MOVE_ITEMS: 'QUESTIONNAIRE_MOVE_ITEMS',

  QUESTIONNAIRE_INIT_STATE: 'QUESTIONNAIRE_INIT_STATE',
  QUESTIONNAIRE_SET_WARNING: 'QUESTIONNAIRE_SET_WARNING'
};